module.exports = __webpack_public_path__ + "img/reyvend-logo.cdab8a2f.png";